export default __webpack_public_path__ + "static/media/cg-merchants.5d0d7de2.svg";